import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/mentions-legales")({
  head: () => ({
    meta: [
      { title: "Mentions légales — Rénergescence" },
      { name: "description", content: "Mentions légales du cabinet Rénergescence — Caroline Balech, Toulouse." },
      { property: "og:url", content: "/mentions-legales" },
    ],
    links: [{ rel: "canonical", href: "https://renergescence.com/mentions-legales" }],
  }),
  component: MentionsLegales,
});

function MentionsLegales() {
  return (
    <article className="py-20 md:py-28">
      <div className="mx-auto max-w-[720px] px-6">
        <h1 className="font-display text-5xl font-light italic md:text-6xl">Mentions légales</h1>

        <div className="mt-12 space-y-10 leading-relaxed" style={{ color: "var(--color-text)" }}>
          <section>
            <h2 className="font-display text-2xl">Éditeur du site</h2>
            <p className="mt-3">Cabinet Rénergescence</p>
            <ul className="mt-2 space-y-1 text-[15px]">
              <li>SIRET : 889 578 415 000 16</li>
              <li>Propriétaire : Caroline BALECH</li>
              <li>Adresse : 3 rue Ledru-Rollin, 31300 Toulouse</li>
              <li>Téléphone : 06 89 67 65 46</li>
              <li>E-mail : contact@renergescence.com</li>
              <li>Responsable de publication : Caroline BALECH</li>
            </ul>
          </section>

          <section>
            <h2 className="font-display text-2xl">Hébergement</h2>
            <p className="mt-3">Ce site et son nom de domaine sont hébergés par la société OVH.</p>
            <ul className="mt-2 space-y-1 text-[15px]">
              <li>Société : OVH</li>
              <li>Adresse : 2 rue Kellermann, 59100 Roubaix — France</li>
            </ul>
          </section>

          <section>
            <h2 className="font-display text-2xl">Informations</h2>
            <p className="mt-3">
              Les informations et documents du site sont présentés à titre indicatif, ne revêtent pas un caractère exhaustif, et ne peuvent engager la responsabilité du propriétaire du site.
            </p>
            <p className="mt-3">
              La propriétaire du site ne peut être tenue responsable des dommages directs et indirects consécutifs à l'accès au site.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl">Propriété et droits d'auteurs</h2>
            <p className="mt-3">
              Sauf mention contraire, tous les éléments accessibles sur le site (textes, images, graphismes, logo, icônes, sons, logiciels, etc.) restent la propriété exclusive de leur auteur, en ce qui concerne les droits de propriété intellectuelle ou les droits d'usage.
            </p>
            <p className="mt-3">
              Toute reproduction, représentation, modification, publication, adaptation de tout ou partie des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite, sauf autorisation écrite préalable de l'auteur.
            </p>
            <p className="mt-3">
              Toute exploitation non autorisée du site ou de l'un quelconque des éléments qu'il contient est considérée comme constitutive d'une contrefaçon et peut être poursuivie en justice.
            </p>
            <p className="mt-3">
              Le logo Rénergescence a été imaginé par Caroline BALECH et réalisé par Marion TRAININI.
            </p>
            <p className="mt-3">
              La marque et le logo reproduits sur le site sont déposés par Caroline BALECH auprès de l'INPI.
            </p>
            <p className="mt-3">Le site a été produit par l'EI MHouse.</p>
          </section>

          <section>
            <h2 className="font-display text-2xl">Médiateur de la consommation</h2>
            <p className="mt-3">
              Conformément aux articles L.616-1 et R.616-1 du code de la consommation, nous proposons un dispositif de médiation de la consommation. L'entité de médiation retenue est : <strong>CNPM — MÉDIATION DE LA CONSOMMATION</strong>. En cas de litige, vous pouvez déposer votre réclamation sur son site :{" "}
              <a href="https://cnpm-mediation-consommation.eu" target="_blank" rel="noopener noreferrer" className="underline" style={{ color: "var(--color-sage-text)" }}>
                cnpm-mediation-consommation.eu
              </a>{" "}
              ou par voie postale en écrivant à CNPM — MÉDIATION — CONSOMMATION, 27 avenue de la Libération, 42400 Saint-Chamond.
            </p>
            <p className="mt-3">TVA non applicable, art. 293 B du CGI.</p>
          </section>

          <section>
            <h2 className="font-display text-2xl">Crédits</h2>
            <p className="mt-3">Rénergescence</p>
            <p className="mt-3 text-sm" style={{ color: "var(--color-muted-foreground)" }}>
              Mentions légales fournies par WebExpress — Version 1.5 — Utilisation libre sous Licence Creative Commons CC BY-NC-ND 3.0 FR / creativecommons.org.
            </p>
            <ul className="mt-4 list-disc space-y-1 pl-5 text-sm" style={{ color: "var(--color-muted-foreground)" }}>
              <li>Articles L111-1 et suivants du Code de la Propriété Intellectuelle du 1er juillet 1992</li>
              <li>Article 41 de la loi du 11 mars 1957</li>
              <li>Article L. 226-13 du Code pénal et la Directive Européenne du 24 octobre 1995</li>
              <li>Articles L.335-2 et suivants du Code de Propriété Intellectuelle</li>
              <li>Loi n° 78-87 du 6 janvier 1978, modifiée par la loi n° 2004-801 du 6 août 2004, relative à l'informatique, aux fichiers et aux libertés</li>
              <li>Articles 38 et suivants de la loi 78-17 du 6 janvier 1978 relative à l'informatique, aux fichiers et aux libertés</li>
              <li>Loi du 1er juillet 1998 transposant la directive 96/9 du 11 mars 1996 relative à la protection juridique des bases de données</li>
              <li>Loi n° 2004-801 du 6 août 2004</li>
              <li>Article 6 de la loi n° 2004-575 du 21 juin 2004 pour la confiance dans l'économie numérique</li>
            </ul>
          </section>
        </div>
      </div>
    </article>
  );
}
